import { useEffect, useState, useCallback } from "react";
import LabelInput from "../../../../../shared/components/labelInput";
import { useForm } from "react-hook-form";
import AddressLookup from "../../../../../shared/components/addressLookup";
import {
  fetchLicenceAuth,
  fetchOverNight,
} from "../../../../../shared/services/simpleListItemsService";
import NewDateTimePicker from "../../../../../shared/components/newDateTimePicker";
import RadioGroup from "../../../../../shared/components/RadioGroup";
import SpAddressMapper from "../mappers/spAddressMapper";
import useAppStateStore from "../../../../../shared/store/AppStateStore";
import QuoteFormWrapper from "../../../../../shared/components/quoteFormWrapper";
import SupportNavigationButtons from "../../../components/support/SupportNavigationButtons";
import { handleSupportNext } from "../../../utils/supportNavUtils";
import useSupportStore from "../../../store/supportStore";
import { useNavigate } from "react-router-dom";

const SpAddress = () => {
  const {
    register,
    watch,
    setValue,
    control,
    trigger,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm({
    defaultValues: SpAddressMapper.get(),
  });

  const STATE = useAppStateStore();
  const addressOptions = [
    {
      value: "new_permanent_home_address",
      label: "New permanent home address",
    },
    { value: "temporary_address", label: "Temporary address" },
    { value: "business_address", label: "Business address" },
  ];

  const [lic, setLic] = useState([]);
  const [overNight, setOverNight] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const convertArrayFormat = useCallback(
    (array) =>
      Array.isArray(array)
        ? array.map((item) => ({
            value: item.listItemId,
            label: item.listItemDescription,
          }))
        : [],
    []
  );

  useEffect(() => {
    setIsLoading(true);
    Promise.all([fetchLicenceAuth(), fetchOverNight()])
      .then(([licData, overNightData]) => {
        setLic(licData);
        setOverNight(overNightData);
      })
      .finally(() => setIsLoading(false));
  }, []);

  const onSubmit = (data) => {
    SpAddressMapper.set(data);
    handleSupportNext(navigate);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <QuoteFormWrapper>
        <h1 className="margin-bottom-30">Address Change</h1>
        <div className="margin-bottom-5">
          <AddressLookup
            register={register}
            watch={watch}
            labelHouse="New House Name or Number"
            labelPostCode="New Postcode"
            setValue={setValue}
            trigger={trigger}
            errors={errors}
            STATE={STATE}
          />
        </div>
        <LabelInput
          id="reasonAddress"
          label="Reason for changing address"
          type="select"
          options={addressOptions}
          control={control}
          errors={errors.reasonAddress}
          placeholder="Select Reason"
          register={register("reasonAddress", { required: "Required" })}
          watch={watch("reasonAddress")}
          trigger={trigger}
          isLoading={isLoading}
        />
        <RadioGroup
          name="overNightHome"
          mainLabel="Will the vehicle be parked on your drive overnight?"
          register={register}
          errors={errors.overNightHome}
        />
        {watch("overNightHome") === "No" && (
          <>
            <LabelInput
              id="locOverNight"
              label="Where is your vehicle located overnight?"
              type="select"
              options={convertArrayFormat(overNight)}
              control={control}
              placeholder="Select location"
              register={register("locOverNight", { required: true })}
              errors={errors.locOverNight}
              watch={watch("locOverNight")}
              trigger={trigger}
              isSearchable={true}
              isLoading={isLoading}
            />
            <LabelInput
              id="overNightPostcode"
              label="What is the overnight postcode?"
              type="text"
              control={control}
              placeholder="Overnight postcode"
              register={register("overNightPostcode", { required: true })}
              errors={errors.overNightPostcode}
              watch={watch("overNightPostcode")}
              trigger={trigger}
              isSearchable={true}
            />
          </>
        )}
        <RadioGroup
          name="exitingLicenseAuth"
          mainLabel="Will your vehicle continue to be licenced by the existing licencing authority disclosed on your policy?"
          register={register}
          errors={errors.exitingLicenseAuth}
        />
        {watch("exitingLicenseAuth") === "No" && (
          <LabelInput
            id="LicenseAuth"
            label="What will be the licencing authority?"
            type="select"
            options={convertArrayFormat(lic)}
            control={control}
            placeholder="Select licence authority"
            register={register("LicenseAuth", { required: true })}
            errors={errors.LicenseAuth}
            watch={watch("LicenseAuth")}
            trigger={trigger}
            isSearchable={true}
            isLoading={isLoading}
          />
        )}
        <NewDateTimePicker
          name="addressEffectiveDateTime"
          label="Effective Date and Time"
          errors={errors.addressEffectiveDateTime}
          setValue={setValue}
          control={control}
          rules={{ required: "Date is required" }}
          watch={watch}
          defaultValue={watch("addressEffectiveDateTime")}
          minDate={new Date()}
        />
        <p className="licPara-12px gray-text margin-top-25">
          You must update your driving licence and taxi badge to match your new
          address. If you own your vehicle, your vehicle plate licence and
          logbook must also be updated.
        </p>
      </QuoteFormWrapper>
      <SupportNavigationButtons isValid={isValid} />
    </form>
  );
};

export default SpAddress;
